module.exports = __webpack_public_path__ + "static/img/award2.0c4e696.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award2.png
// module id = MgnM
// module chunks = 7